import script from "./StoreListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./StoreListPage.vue?vue&type=script&setup=true&lang=ts"

import "./StoreListPage.vue?vue&type=style&index=0&id=bdfcfbca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdfcfbca"]])

export default __exports__